import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faDollarSign, faRubleSign } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { CurrencyTypes } from 'src/types.d';

import useI18n from '@i18n';

import HeaderDropdown, { HeaderDropdownPositions } from '../HeaderDropdown';

export interface ICurrency {
    id: string;
    icon: IconDefinition;
    name: CurrencyTypes;
}

export const currencies: ICurrency[] = [
    {
        id: 'dollars',
        icon: faDollarSign,
        name: CurrencyTypes.USD,
    },
    {
        id: 'rubles',
        icon: faRubleSign,
        name: CurrencyTypes.RUB,
    },
];

interface ICurrencySwitchProps {
    currentCurrency: ICurrency;
    setCurrentCurrency: (currency: ICurrency) => void;
}

const CurrencySwitch: React.FC<ICurrencySwitchProps> = ({
    currentCurrency,
    setCurrentCurrency,
}) => {
    const { t } = useI18n('Base');

    const getCurrencyById = (id: string) => currencies.find(el => el.id === id);

    const currencyDropdownOptions = [
        {
            label: t('Dollars'),
            id: 'dollars',
            icon: faDollarSign,
            callback: () => setCurrentCurrency(getCurrencyById('dollars') || currencies[0]),
        },
        {
            label: t('Rubles'),
            id: 'rubles',
            icon: faRubleSign,
            callback: () => setCurrentCurrency(getCurrencyById('rubles') || currencies[1]),
        },
    ];

    return (
        <HeaderDropdown
            options={currencyDropdownOptions}
            position={HeaderDropdownPositions.right}
            title={t('Choose a currency')}
            itemClassName="pt-1 text-blueGray-500"
            itemsListClassName="gap-[4px]"
        >
            {visible => (
                <div
                    className={clsx(
                        'flex items-center h-full cursor-pointer select-none text-blueGray-800',
                    )}
                >
                    <div
                        id="CurrencySwitchButton"
                        className="relative flex items-center justify-center w-16 h-full text-h2"
                    >
                        {visible && <div className="absolute w-full bg-red-400 h-0.5 -bottom-px" />}
                        <FontAwesomeIcon icon={currentCurrency.icon} id="CurrencySwitchIcon" />
                    </div>
                </div>
            )}
        </HeaderDropdown>
    );
};

export default CurrencySwitch;
